import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ProductAnalysisModel } from './product-analysis.model';

export class ProductAnalysisResponseModel extends GlobalResponseObject {
    data?: ProductAnalysisModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: ProductAnalysisModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}